import { getParamUrl } from "@/common/ts/share";
import Stroage from "@/common/ts/stroage";
import locale from 'element-ui/lib/locale';
const stroage = new Stroage();
const VueCookies = $cookies;

import {
  setKeywordsDescription,
  setTitle,
  asyncLoadMessage,
} from "@/assets/js/router.extends.js";

Vue.use(VueI18n);

function getNavigatorLang() {
  let lang = navigator.language || navigator.userLanguage;
  console.log("浏览器语言：", lang, lang.toLowerCase());
  lang = lang.toLowerCase();
  switch (lang) {
    //英文
    case "en-us":
    case "en":
      return "en_US";
    //中文繁体
    case "zh-tw":
      return "zh_TW";
    //中文简体
    case "zh-cn":
    case "zh":
      return "zh_CN";
    //韩文
    case "ko-kr":
    case "ko":
      return "ko_KR";
    // 葡萄牙语（巴西）
    case "pt_BR":
      case "pt":
        return "pt_BR";
    // 日文
    case 'ja_JP':
    case 'ja':
      return 'ja_JP'
    //越南文
    case "vi-vw":
    case "vi":
      return "vi_VN";
    //印尼语
    case "id_id":
      return "id_ID";
    //其他：中文简体
    case "tr_TR":
    case "tr":
      return "tr_TR";
    case "ru_Ru":
    case "ru":
      return "ru_Ru";
    case "fr":
     return "fr_FR";
    default:
      return "en_US";
  }
}

window.localeLanguage =
  getParamUrl("lang") ||
  VueCookies.get("BIKING_LANGUAGE") ||
  stroage.getStorageSync("language") ||
  getNavigatorLang() ||
  "zh_CN";

let messages = {};

if (!window.isMobile) {
  messages.zh_CN = {
    ...require("./lang/zh.js"),
    ...ELEMENT.lang.zhCN,
    ...require("./lang/public/zh.js"),
  };
  messages.zh_TW = {
    ...require("./lang/tw.js"),
    ...ELEMENT.lang.zhTW,
    ...require("./lang/public/tw.js"),
  };
  messages.en_US = {
    ...require("./lang/en.js"),
    ...ELEMENT.lang.en,
    ...require("./lang/public/en.js"),
  };
  messages.ko_KR = {
    ...require("./lang/kr.js"),
    ...ELEMENT.lang.ko,
    ...require("./lang/public/kr.js"),
  };
  messages.pt_BR = {
    ...require("./lang/pt_BR.js"),
    ...ELEMENT.lang.en,
    ...require("./lang/public/pt_BR.js"),
  };
  messages.ja_JP = {
    ...require("./lang/ja_JP.js"),
    ...ELEMENT.lang.en,
    ...require("./lang/public/ja_JP.js"),
  };
  messages.vi_VN = {
    ...require("./lang/vi.js"),
    ...ELEMENT.lang.en,
    ...require("./lang/public/vi.js"),
  };
  messages.id_ID = {
    ...require("./lang/ba.js"),
    ...ELEMENT.lang.ba,
    ...require("./lang/public/ba.js"),
  };
  messages.tr_TR = {
    ...require("./lang/tr.js"),
    ...ELEMENT.lang.en,
    ...require("./lang/public/tr.js"),
  };
  messages.ru_Ru = {
    ...require("./lang/ru.js"),
    ...ELEMENT.lang.en,
    ...require("./lang/public/ru.js"),
  };
    messages.fr_FR = {
    ...require("./lang/fr.js"),
    ...ELEMENT.lang.en,
    ...require("./lang/public/fr.js"),
  };
} else {
  let res = require("./lang/res/index.js");
  messages.zh_CN = {
    res: res.ch,
    transferDialog: res.transferDialog_ch,
    ...require("./lang/public/zh"),
  };
  messages.zh_TW = {
    res: res.tw,
    transferDialog: res.transferDialog_tw,
    ...require("./lang/public/tw"),
  };
  messages.en_US = {
    res: res.en,
    transferDialog: res.transferDialog_en,
    ...require("./lang/public/en"),
  };
  messages.ko_KR = {
    res: res.kr,
    transferDialog: res.transferDialog_kr,
    ...require("./lang/public/kr"),
  };
  messages.pt_BR = {
    res: res.pt,
    transferDialog: res.transferDialog_pt,
    ...require("./lang/public/pt_BR"),
  };
  messages.ja_JP = {
    res: res.ja_JP,
    transferDialog: res.transferDialog_ja,
    ...require("./lang/public/ja_JP"),
  };
  messages.vi_VN = {
    res: res.vi_VN,
    ...require("./lang/vi.js"),
    ...ELEMENT.lang.vi,
    ...require("./lang/public/vi.js"),
  };
  messages.id_ID = {
    ...require("./lang/ba.js"),
    ...ELEMENT.lang.ba,
    ...require("./lang/public/ba.js"),
  };
  messages.tr_TR = {
    res: res.tr_TR,
    ...require("./lang/tr.js"),
    ...ELEMENT.lang.tr,
    ...require("./lang/public/tr.js"),
  };
  messages.ru_Ru = {
    res: res.ru_Ru,
    ...require("./lang/ru.js"),
    ...ELEMENT.lang.en,
    ...require("./lang/public/ru.js"),
  };
    messages.fr_FR = {
    res: res.fr_FR,
    ...require("./lang/fr.js"),
    ...ELEMENT.lang.fr,
    ...require("./lang/public/fr.js"),
  };
}

const i18n = new VueI18n({
  locale: window.localeLanguage || 'zh_CN',
  // 语言标识，可以通过cooke获取getcookie('playln', 'en')
  //this.$i18n.locale  // 通过切换locale的值来实现语言切换
  messages,
});

//注册 ELEMENT 国际化
window.isMobile ||
  Vue.use(ELEMENT, {
    i18n: (key, value) => i18n.t(key, value),
  });
locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换export default i18n

//动态加载国际化文件
async function loadFile(lang) {
  //console.log(this.$route);
  if (
    this.$route.meta.i18n &&
    typeof this.$route.meta.i18n[lang] == "function" &&
    !this.$route.meta[`i18n_${lang}_load`]
  ) {
    await asyncLoadMessage(lang, this.$route.meta.i18n[lang]);
    //记录已加载过标记
    this.$route.meta[`i18n_${lang}_load`] = true;
    return;
  } else {
    return;
  }
}

//语言设置函数
function langSet(lang) {
  let old = i18n.locale;

  VueCookies.set("BIKING_LANGUAGE", lang);

  stroage.setStorageSync("language", lang);
  localStorage.setItem("_language", lang);
  window.localeLanguage = i18n.locale = lang;

  let route = this.$route;

  //页面标题title切换
  setTitle(route);
  //页面keywords切换
  setKeywordsDescription(route);

  //发布切换
  this.$bus.emit("langSetCallback", lang, old);

  setAppleTouchIcon(lang);

  //需要订阅的组件
  /*

    this.$bus.on('langSetCallback', (lang)=>{
        console.log(lang)
    });

    或者

    在组件内 methods 中 添加 langSetCallback 回调函数, 切换语言时会自动触发该函数
    methods: {
        ....
        langSetCallback(lang){ .... }
        ....
    }

    */
}

//切换apple-touch-icon图标
function setAppleTouchIcon(lang) {
  let meta = document.querySelector("link[rel='apple-touch-icon']");
  let href = [];
  if (meta && meta.href) {
    href = meta.href.split("/");
    href.pop();
    href.push(
      lang.indexOf("zh") > -1 ? "custom_icon.jpg" : "custom_icon_en.jpg"
    );
    meta.href = href.join("/");
  }
}
setAppleTouchIcon(window.localeLanguage);

//全局语言切换方法
Vue.prototype.langSet = function (lang = "zh_CN") {
  if (lang == i18n.locale) {
    return;
  }

  //langSet.call(this, lang);

  loadFile.call(this, lang).then(() => {
    langSet.call(this, lang);
    // 异步设置
    // clearTimeout(window.langsetTimeout);
    // window.langsetTimeout = null;
    // window.langsetTimeout = setTimeout(() => {
    //     langSet.call(this, lang);
    // }, 50);
  });
};

//提供给测试妹子查询用的 + 动态加载国际化文件时用
window._i18n = i18n;

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js